import { render, staticRenderFns } from "./BsnPlnDetail.vue?vue&type=template&id=1b184a0b&"
import script from "./BsnPlnDetail.vue?vue&type=script&lang=js&"
export * from "./BsnPlnDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports